var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbMessengerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224 226"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-messenger-icon_svg__a",
    y1: "6.76%",
    x2: "50%",
    x1: "50%",
    y2: "95.6%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068FF",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fb-messenger-icon_svg__a)",
    d: "M41.255 185.52v40.2l37.589-21.37C89.322 207.37 100.46 209 112 209c61.86 0 112-46.79 112-104.5C224 46.786 173.86 0 112 0 50.144 0 0 46.786 0 104.5c0 32.68 16.078 61.86 41.255 81.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.04 75.878L39.639 139.83l54.97-30.16 28.721 30.16 60.06-63.952-54.36 29.632-28.99-29.632z"
  })));
}

export default __webpack_public_path__ + "./fonts/fb-messenger-icon.0f173d34a8caf9b9b5b0cad5ad733e8e.svg";
export { SvgFbMessengerIcon as ReactComponent };